import { exists, SystemCode, SystemCodeFromJSON } from '@/api'
import { defaultSystemCode } from '@/api/models/system-code/SystemCode'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface ReserveForwardingRequestStatus {
  reserveId: number
  reserveRevision: number
  requestUserId: string
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  collectionNo: string
  searchType: SystemCode
  forwardLevel: string
  displayTitle: string
  forwardRequestBranchCode: SystemCode
  displayAuthor: string
  displayPublisher: string
  displayMemo: string
  collectionFlag: CollectionFlag
}

export function ReserveForwardingRequestStatusFromJSON(
  json: any
): ReserveForwardingRequestStatus {
  return {
    reserveId: exists(json, 'reserve_id') ? json.reserve_id : 0,
    reserveRevision: exists(json, 'reserve_revision')
      ? json.reserve_revision
      : 0,
    requestUserId: exists(json, 'request_user_id') ? json.request_user_id : '',
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    forwardLevel: exists(json, 'forward_level') ? json.forward_level : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    forwardRequestBranchCode: exists(json, 'forward_request_branch_code')
      ? SystemCodeFromJSON(json.forward_request_branch_code)
      : defaultSystemCode(),
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection
  }
}
